import { Phone, Mail, MessageCircle } from "lucide-react";
import { mailLink, telLink, waLink } from "../lib/company";
import { useT } from "../lib/i18n";

export const ContactButtons = ({ message, subject, prefix = "contact" }) => {
  const { btn } = useT();
  return (
  <div className="flex flex-col sm:flex-row gap-3">
    <a href={waLink(message ?? btn.waDefault)} target="_blank" rel="noreferrer" data-testid={`${prefix}-whatsapp-btn`}
      className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-[#1F8F4E] text-white px-6 py-4 text-sm font-semibold hover:bg-[#17703c] transition-colors">
      <MessageCircle className="w-4 h-4" /> {btn.wa}
    </a>
    <a href={telLink} data-testid={`${prefix}-call-btn`}
      className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-[var(--ink)] text-white px-6 py-4 text-sm font-semibold hover:bg-[var(--red)] transition-colors">
      <Phone className="w-4 h-4" /> {btn.call}
    </a>
    <a href={mailLink(subject ?? btn.mailDefault)} data-testid={`${prefix}-email-btn`}
      className="flex-1 inline-flex items-center justify-center gap-2 rounded-full border border-[var(--ink)] px-6 py-4 text-sm font-semibold hover:bg-[var(--ink)] hover:text-white transition-colors">
      <Mail className="w-4 h-4" /> {btn.email}
    </a>
  </div>
  );
};
